import React, { useState } from 'react'

import {
    Search,
    Message,
    DarkMode,
    LightMode,
    Notifications,
    Help,
    Menu,
    Close
} from '@mui/icons-material'

import { useDispatch, useSelector } from 'react-redux'
import { setMode, setLogout } from "state"
import { useNavigate } from 'react-router-dom'
import { Box, FormControl, IconButton, InputBase, MenuItem, Select, Typography, useMediaQuery, useTheme } from '@mui/material'
import FlexBetween from 'components/FlexBetween'
import NotificationIcon from 'components/NotificationIcon'

const Navbar = () => {
    const [isMobileMenuToggled, setIsMobileMenuToggled] = useState(false)
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const user = useSelector((state) => state.user)
    const isNonMobileScreens = useMediaQuery("(min-width: 1000px)")

    const theme = useTheme();
    const neutralLight = theme.palette.neutral.light;
    const dark = theme.palette.neutral.dark

    const background = theme.palette.background.default;
    const primaryLight = theme.palette.primary.light;
    const alt = theme.palette.background.alt;

    const fullName = `${user?.firstName} ${user?.lastName}`;
    // const fullName = `Fake Person`;


    return (
        <FlexBetween padding='1rem 6%' backgroundColor={alt}>
            <FlexBetween gap={"1.75rem"}>
                <Typography
                    fontWeight="bold"
                    fontSize="clamp(1rem, 2rem, 2.25rem)"
                    color="primary"
                    onClick={() => navigate('/home')}
                    sx={{
                        "&:hover": {
                            color: primaryLight,
                            cursor: 'pointer',
                        },
                    }}

                >
                    SocioSync
                </Typography>

                {isNonMobileScreens && (
                    <FlexBetween backgroundColor={neutralLight} borderRadius="9px" gap="3rem" padding="0.1rem  1.5rem" >
                        <InputBase placeholder='Search...' />
                        <IconButton>
                            <Search />
                        </IconButton>
                    </FlexBetween>
                )}
            </FlexBetween>


            {/* // ~ DESKTOP NAVBAR */}
            {isNonMobileScreens ? (
                <FlexBetween gap='2rem' >
                    <Message sx={{ fontSize: '25px' }} />
                    <NotificationIcon />
                    <IconButton onClick={() => dispatch(setMode())}>
                        {theme.palette.mode === 'dark' ? (
                            <DarkMode sx={{ fontSize: '25px' }} />
                        ) : (
                            <LightMode sx={{ fontSize: '25px', color: dark }} />
                        )}
                    </IconButton>
                    <FormControl variant='standard' value={fullName}>
                        <Select
                            value={fullName}
                            sx={{
                                backgroundColor: neutralLight,
                                width: '150px',
                                borderRadius: '0.25rem',
                                p: '0.25rem 1 rem',
                                "& .MuiSvgIcon": {
                                    pr: "0.25rem",
                                    width: '3rem'
                                },
                                "& .MuiSelect-select:focus": {
                                    backgroundColor: neutralLight
                                }
                            }}
                            input={<InputBase />}
                        >
                            <MenuItem value={fullName} >
                                <Typography style={{ padding: '0px 12px' }}>{fullName}</Typography>
                            </MenuItem>
                            <MenuItem onClick={() => dispatch(setLogout())}>
                                <span style={{ padding: '0px 12px' }}>Log Out</span>
                            </MenuItem>
                        </Select>
                    </FormControl>
                </FlexBetween>
            ) : (
                <IconButton onClick={() => setIsMobileMenuToggled(!isMobileMenuToggled)}>
                    <Menu />
                </IconButton>
            )}

            {/* //~ MOBILE VIEW */}
            {!isNonMobileScreens && isMobileMenuToggled && (
                <Box position="fixed"
                    right='0'
                    bottom='0'
                    height='100%'
                    zIndex='10'
                    maxWidth='500px'
                    minWidth='300px'
                    backgroundColor={background}
                >

                    {/* //  ~ CLOSE ICON */}
                    <Box display='flex' justifyContent='flex-end' p='1rem' >
                        <IconButton onClick={() => setIsMobileMenuToggled(!isMobileMenuToggled)}>
                            <Close />
                        </IconButton>
                    </Box>

                    {/* //  ~ MENU ITEMS */}
                    <FlexBetween display='flex' flexDirection='column' justifyContent='center' alignItems='center' gap='2rem'>
                        <IconButton sx={{ fontSize: '25px' }} onClick={() => dispatch(setMode())}>
                            {theme.palette.mode === 'dark' ? (
                                <DarkMode sx={{ fontSize: '25px' }} />
                            ) : (
                                <LightMode sx={{ fontSize: '25px', color: dark }} />
                            )}
                        </IconButton>
                        <Message sx={{ fontSize: '25px' }} />
                        {/* <Notifications sx={{ fontSize: '25px' }} /> */}
                        <NotificationIcon />

                        {/* <Help sx={{ fontSize: '25px' }} /> */}
                        <FormControl variant='standard' value={fullName}>
                            <Select
                                value={fullName}
                                sx={{
                                    backgroundColor: neutralLight,
                                    width: '150px',
                                    borderRadius: '0.25rem',
                                    p: '0.25rem 1 rem',
                                    "& .MuiSvgIcon": {
                                        pr: "0.25rem",
                                        width: '3rem'
                                    },
                                    "& .MuiSelect-select:focus": {
                                        backgroundColor: neutralLight
                                    }
                                }}
                                input={<InputBase />}
                            >
                                <MenuItem value={fullName}>
                                    <Typography>{fullName}</Typography>
                                </MenuItem>
                                <MenuItem onClick={() => dispatch(setLogout())}>
                                    Log Out
                                </MenuItem>
                            </Select>
                        </FormControl>
                    </FlexBetween>
                </Box>
            )}
        </FlexBetween >
    )
}

export default Navbar;